import * as React from "react";
import { Portal } from "@radix-ui/themes";
import { MoreMenuItems } from "./MoreMenuItems.tsx";
import { StashItTheme } from "../../../app/StashItTheme.tsx";
import { useRoute } from "../../../routing/router.ts";
import { useEffect } from "react";
import "../../../layout/layout.css";

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => unknown;
}

/** The bottom nav's More: a sheet up from the bottom with the rest of the app in it. */
export const MoreMenu: React.FC<Props> = ({ isOpen, setIsOpen }) => {
  // A bit hacky but will do for now
  const route = useRoute();
  useEffect(() => {
    setIsOpen(false);
  }, [route.name]);

  return (
    <Portal>
      <StashItTheme>
        <div
          className="more-sheet"
          data-comment={"MoreMenu"}
          style={{ pointerEvents: isOpen ? "auto" : "none" }}
          aria-hidden={!isOpen}
        >
          <div
            className="more-sheet-scrim"
            style={{ opacity: isOpen ? 1 : 0 }}
            onClick={() => setIsOpen(false)}
          />
          <div
            className="more-sheet-panel"
            style={{
              opacity: isOpen ? 1 : 0,
              transform: `translateY(${isOpen ? "0" : "40%"})`,
            }}
          >
            <div className="more-sheet-handle" />
            <MoreMenuItems />
          </div>
        </div>
      </StashItTheme>
    </Portal>
  );
};
